import ErrorBoundary from '@components/Error/ErrorBoundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { jotaiStore } from '@atoms';
import { ErrorGuard } from '@components/Error/ErrorGuard';
import { AppRouter } from '@routes/AppRouter';
import { Provider } from 'jotai';
import {
  AppContextProviders,
  ConfigContextProvider,
  useConfigContext,
} from '@fe-core';
import { Settings } from 'luxon';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  },
});

const AppWithConfig = () => {
  const { config } = useConfigContext();
  const isLoggedIn = config?.loggedIn;
  const locale = config.locale || 'en';
  Settings.defaultLocale = locale;

  const contexts = [
    'branding' as const,
    'language' as const,
    ...(isLoggedIn ? ['user' as const] : []),
  ];

  return (
    <AppContextProviders
      locale={locale}
      bundles={['fe-learner']}
      targetElementQuery="html"
      contexts={contexts}
      brandingId={config?.genericBrandingId as number}
    >
      <ErrorGuard>
        <AppRouter />
      </ErrorGuard>
    </AppContextProviders>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Provider store={jotaiStore}>
          <ConfigContextProvider>
            <AppWithConfig />
          </ConfigContextProvider>
        </Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
